import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCountertopSearchText = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.countertop.searchText;

export const searchText = setCalculationModeCountertopSearchText(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_COUNTERTOP_SEARCH_TEXT',
  ''
);
